import { controls,grouped } from "../controls";
const farms = {
label: "Farms",
pageLabel: "Farms",starting: true,url: "autogen",
formActions: { edit: { allow: true },delete:{allow:true} },
pageType: "history",
filter:[
...controls.displayText({ tab: "filter", label: "District"}),
...controls.oc({ tab: "filter", c: "District", placeHolder: "District Code", name: "Farm-district-district_code",fastpath:"districts"}),
...controls.showData({ tab: "filter", displaytype: "capital", data: "Farm-district-district_display"}),
...controls.displayText({ tab: "filter", label: "Taluka"}),
...controls.oc({ tab: "filter", c: "Taluka", placeHolder: "Taluka Code", name: "Farm-taluka-taluka_code",fastpath:"talukas"}),
...controls.showData({ tab: "filter", displaytype: "capital", data: "Farm-taluka-taluka_display"}),
...controls.displayText({ tab: "filter", label: "Village"}),
...controls.oc({ tab: "filter", c: "Village", placeHolder: "Village Code", name: "Farm-village-village_code",fastpath:"villages"}),
...controls.showData({ tab: "filter", displaytype: "capital", data: "Farm-village-village_display"}),
...controls.displayText({ tab: "filter", label: "Customer"}),
...controls.oc({ tab: "filter", c: "Customer", placeHolder: "Customer Code", name: "Farm-customer-customer_code",fastpath:"customers"}),
...controls.showData({ tab: "filter", displaytype: "capital", data: "Farm-customer-customer_display"}),
]
,form:[
...controls.displayText({ tab: "general", label: "District",star:false}),
...controls.oc({ tab: "general", c: "District", placeHolder: "District Code", name: "district_code", isRequired:false,fastpath:"districts"}),
...controls.showData({ tab: "general", displaytype: "capital", data: "district_display"}),
...controls.displayText({ tab: "general", label: "Taluka",star:false}),
...controls.oc({ tab: "general", c: "Taluka", placeHolder: "Taluka Code", name: "taluka_code", isRequired:false,fastpath:"talukas"}),
...controls.showData({ tab: "general", displaytype: "capital", data: "taluka_display"}),
...controls.displayText({ tab: "general", label: "Village",star:false}),
...controls.oc({ tab: "general", c: "Village", placeHolder: "Village Code", name: "village_code", isRequired:false,fastpath:"villages"}),
...controls.showData({ tab: "general", displaytype: "capital", data: "village_display"}),
...controls.displayText({ tab: "general", label: "Khata No",star:false}),
...controls.text({ tab: "general",  placeHolder: "", name: "khata_no",isRequired:false,maxlength:10}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Survey No",star:false}),
...controls.text({ tab: "general",  placeHolder: "", name: "survey_no",isRequired:false,maxlength:10}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Gat No",star:false}),
...controls.text({ tab: "general",  placeHolder: "", name: "gat_no",isRequired:false,maxlength:10}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Jirayat Quantity"}),
...controls.floatOnly({ tab: "general",  placeHolder: "", name: "jirayat_quantity",maxlength:10}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Bagayat Quantity"}),
...controls.floatOnly({ tab: "general",  placeHolder: "", name: "bagayat_quantity",maxlength:10}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Tari Quantity"}),
...controls.floatOnly({ tab: "general",  placeHolder: "", name: "tari_quantity",maxlength:10}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Warkas Quantity"}),
...controls.floatOnly({ tab: "general",  placeHolder: "", name: "warkas_quantity",maxlength:10}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Other Quantity"}),
...controls.floatOnly({ tab: "general",  placeHolder: "", name: "other_quantity",maxlength:10}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Pot Kharab Quantity"}),
...controls.floatOnly({ tab: "general",  placeHolder: "", name: "pot_kharab_quantity",maxlength:10}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Mortgage Amount"}),
...controls.floatOnly({ tab: "general",  placeHolder: "", name: "mortgage_amount",maxlength:18}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Mortgage Authority",star:false}),
...controls.text({ tab: "general",  placeHolder: "", name: "mortgage_authority",isRequired:false,maxlength:50}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Crop",star:false}),
...controls.oc({ tab: "general", c: "Crop", placeHolder: "Crop Code", name: "crop_code", isRequired:false,fastpath:"crops"}),
...controls.showData({ tab: "general", displaytype: "capital", data: "crop_display"}),
...controls.displayText({ tab: "general", label: "Latitude"}),
...controls.floatOnly({ tab: "general",  placeHolder: "", name: "latitude",maxlength:10}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Longitude"}),
...controls.floatOnly({ tab: "general",  placeHolder: "", name: "longitude",maxlength:10}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
]
,history:{
perPage: 10,
reportHeader: "Farms",
pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
clickable: true,
displayColumns: [
{Header: "Sr",type: "autoinc",accessor: "srno",align: "center",width: 30},
{Header: "First Name",accessor: "Farm-customer-individual_details-first_name",},
{Header: "First Name",accessor: "Farm-customer-individual_details-first_name",},
{Header: "District",accessor: "Farm-district-district_display",},
{Header: "Taluka",accessor: "Farm-taluka-taluka_display",},
{Header: "Village",accessor: "Farm-village-village_display",},
]}};
export default farms;